<template>
  <ks-flex
      :justify="showFacility ? 'between' : 'end'"
      :styles="`z-index: ${zIndex};`"
      wrap="nowrap"
      :width="width"
      :style="screenSizeId >= 3 ? 'flex-grow: 1; padding: 0 15px;' : ``"
  >
    <slot/>

    <!--        <div v-else></div>-->

    <!--    {{ facilityList() }}-->
    <ks-facility-selector
        v-if="showFacility"
        :showFacility="showFacility"
        :dataProvider="dataProvider"
        :dataProviderArray="dataProviderArray"
        :facilityField="facilityField"
        :defaultFacilityId="defaultFacilityId"
        :useDataProviderList="useDataProviderList"
        @onSelectedFacilityChange="$emit('onSelectedFacilityChange', $event)"
    />
    <ks-search
        :showSelectorModes="showSelectorModes"
        :dataProvider="dataProvider"
        v-if="showSearch"
        :flexGrow="false"
        :defaultSearchWidth="null"
        :searchMode="searchMode"
        :searchModeId="searchModeId"
    />
    <div class="d-flex" v-if="showFields || showViews">
      <ks-block
          v-if="(columnHiddenEnable && activeViewType === 'table') && showFields"
      >
        <ks-data-dropdown
            :openInHover="false"
            :buttonClass="['btn btn-sm' + (screenSizeId >= 3 ? ' btn-light dropdown-toggle' : ' btn-link p-1 m-1')]"
            :contentClass="['dropdown-menu-right']"
        >
          <template #button>
            <ks-icon
                icon="fa fa-eye fa-fw"
                :abbreviated="false"
            />
          </template>
          <template #content>
            <a v-for="column of columns"
               class="dropdown-item"
               :class="[{'text-muted':column.isHidden, 'text-dark':!column.isHidden }]"
               @click.prevent="column.isHidden = !column.isHidden"
               :key="'column-'+column.dataSource"
               v-if="column.hiddenable"
            >
              <template v-if="column.iconClass && column.iconClass.length > 0">
                <ks-icon :icon="column.iconClass" :abbreviated="false"/>
              </template>
              <template v-else>
                {{ column.label || column.title || column.dataSource }}
              </template>
              <ks-icon
                  v-show="column.isHidden"
                  style="float:right;font-size: 0.75rem;"
                  icon="fa fa-eye-slash"
                  :abbreviated="false"
              />
              <ks-icon
                  v-show="!column.isHidden"
                  style="float:right;font-size: 0.75rem;"
                  icon="fa fa-eye"
                  :abbreviated="false"
              />
            </a>
          </template>
        </ks-data-dropdown>
      </ks-block>

      <div
          v-if="avalibleViewTypes.length > 0 && showViews"
          class="dropdown float-right"
      >
        <button
            v-for="button in viewTypeButtons"
            :class="screenSizeId >= 3 ? 'btn btn-light btn-sm dropdown-toggle' : 'btn btn-link p-1 m-1'"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            v-show="activeViewType === button.active_view_type"
        >
          <ks-icon
              :icon="button.icon"
              :abbreviated="false"
          />
        </button>
        <div
            class="dropdown-menu dropdown-menu-right"
            style="min-width: 4rem; font-size: 0.9rem"
        >
          <a
              v-for="type in avalibleViewTypes"
              class="dropdown-item"
              @click.prevent="setActiveViewType(type, true)"
          >
            <i
                :class="[{
                          'fas fa-bars fa-fw': type === 'table',
                          'fas fa-th fa-fw': type === 'gallery',
                          'fas fa-table fa-fw': type === 'grid' ,
                          'fas fa-map fa-fw': type === 'map',
                          'far fa-map fa-fw': type === 'unit-map',
                          'far fa-calendar-alt fa-fw': type === 'calendar',
                          'fas fa-chart-bar fa-fw': type === 'chart-bar',
                          'fas fa-chart-pie fa-fw': type === 'chart-pie',
                          'fas fa-chart-line fa-fw': type === 'chart-line'
                      }]"
            />
          </a>
        </div>
      </div>
    </div>
  </ks-flex>
</template>

<script>
export default {
  name:     'ks-list-controller',
  props:    {
    showFacility:         {type: Boolean, default: false},
    showSelectorModes:    {type: Boolean, default: true},
    showSearch:           {type: Boolean, default: true},
    width:                {type: String, default: ''},
    zIndex:               {type: String, default: '100'},
    columnHiddenEnable:   {type: Boolean, default: true},
    avalibleViewTypes:    {
      type: Array, default: () => {
        return []
      }
    }, //["table", "grid", "map", "calendar", "gallery(free)", "chart-bar", "chart-pie"]
    beforeViewTypeChange: {type: Function, default: null},
    dataProvider:         {type: String},
    dataProvider2:        {type: String},
    dataProviderArray:    {type: Array},
    facilityField:        {type: String, default: 'facility_id_csv'},
    searchMode:           {type: String, default: null},
    searchModeId:         {type: Number, default: null},
    defaultFacilityId:    {type: Number, default: null},
    useDataProviderList:  {type: Boolean, default: false}
  },
  watch:    {
    /*defaultFacilityId(val) {
      this.selectedFacility = {'id': val}
    },
    facilityList(val, oldVal) {
      this.selectedFacility = {'id': null};
      app.getDataprovider('facility_data_provider').updateFilters({'facility_id_csv': ''})
      this.setFacilityIfSingle(4000);
      this.reloadList();
    },*/

    activeViewType: function (val, oldval) {
      if (oldval !== null) {
        this.$emit('onViewTypeChange', this);
      }
    }
  },
  computed: {
    facilityList() {
      this.l_facilityList = app.getDataprovider('facility_data_provider')?.list;
      return this.l_facilityList;
    },
    selected_campaigns() {
      return global.app.store.state.rms_ui.auth.selected_campaigns;
    },
    showViews:  {
      get() {
        return global.app.store.state.ks_app.global_data.showViews;
      },
      set(val) {
        app.store.commit('ks_app/global_data/setShowViews', val);
      }
    },
    showFields: {
      get() {
        return global.app.store.state.ks_app.global_data.showFields;
      },
      set(val) {
        app.store.commit('ks_app/global_data/setShowFields', val);
      }
    },
    activeViewType() {
      return this.$parent.activeViewType;
    },
    columns() {
      return this.$parent.columns;
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    }
  },
  methods:  {
    /*setFacilityIfSingle(time = 0) {
      setTimeout(() => {
        let facility_data_provider = app.getDataprovider('facility_data_provider');
        if (facility_data_provider.list.length === 1) {
          this.selectedFacility = facility_data_provider.list[0];
        }
      }, time)
    },*/
    /*reloadList(time = 1000) {
      let _this = this;
      if (this.useDataProviderList) {
        setTimeout(() => {
          _this.dataProviderArray.forEach(dp => {
            let data_provider            = app.getDataprovider(dp);
            let filters                  = {}
            filters[_this.facilityField] = _this.selectedFacility?.id
            data_provider?.updateFilters(filters);
            data_provider?.loadList();
          })
        }, time)
      } else {
        let data_provider           = app.getDataprovider(this.dataProvider);
        let filters                 = {}
        filters[this.facilityField] = this.selectedFacility?.id;

        data_provider?.updateFilters(filters);
        data_provider?.loadList();

        //TODO remove this,find all instances, and utilize useDataProviderList instead
        if (this.dataProvider2) {
          let data_provider2 = app.getDataprovider(this.dataProvider2);
          data_provider2?.updateFilters(filters);
          data_provider2?.loadList();
        }
      }
    },*/
    /*setFacility(val) {
      if (val?.input) {
        let list              = app.getDataprovider('facility_data_provider').list;
        let facility          = list.find((l) => l.id === val.input);
        this.selectedFacility = facility;
        this.$emit('onSelectedFacilityChange', facility);
        this.showFacilitySelector = false;
        this.reloadList();
      }
    },*/
    setActiveViewType(type) {
      this.$parent.setActiveViewType(type, this.beforeViewTypeChange);
    }
  },
  data() {
    return {
      viewTypeButtons: [
        {'active_view_type': 'table', 'icon': 'fas fa-bars fa-fw'},
        {'active_view_type': 'gallery', 'icon': 'fas fa-th fa-fw'},
        {'active_view_type': 'grid', 'icon': 'fas fa-table fa-fw'},
        {'active_view_type': 'map', 'icon': 'fas fa-map fa-fw'},
        {'active_view_type': 'unit-map', 'icon': 'far fa-map fa-fw'},
        {'active_view_type': 'calendar', 'icon': 'far fa-calendar-alt fa-fw'},
        {'active_view_type': 'chart-bar', 'icon': 'fas fa-chart-bar fa-fw'},
        {'active_view_type': 'chart-pie', 'icon': 'fas fa-chart-pie fa-fw'},
        {'active_view_type': 'chart-line', 'icon': 'fas fa-chart-line fa-fw'},
      ],
    }
  }
}
</script>
